import bin from "./images/bin.svg";
import arrow from "./images/arrow.svg";
import { deleteSoundTracksThunk } from "../features/SoundTracksReducer";
import { useDispatch } from "react-redux"
import { deleteUserPostThunk } from "../features/PostManagementReducer";
import { deleteReportManagementThunk, updateReportManagementThunk } from "../features/ReportManagementReducer";


import { deleteCashOutThunk, updateCashOutThunk } from "../features/CashOutReducer";

import { Tooltip } from 'antd';
import { confirmAlert } from 'react-confirm-alert';
import { deleteUserManagementThunk, updateUserManagementThunk } from "../features/UserManagementReducer";
import { useState } from "react";
import { deleteAdminTracksThunk } from "../features/AdminTrackReducer";
import { deletePostReportThunk, deleteUserReportedPostThunk } from "../features/PostReportReducer";

import DeleteModal from "../components/Modal/DeleteModal";
import "./styles/Alert.css";
import AlertModal from "../components/Modal/AlertModal";
import moment from "moment"
import { resetValue } from "../features/SearchReducer";
import { deleteDonateHistoryThunk } from "../features/DonateReducer";

export function submit(title, message, cb, rejectCB = () => { }) {
    confirmAlert({
        title,
        message,
        buttons: [
            {
                label: 'Yes',
                onClick: () => cb()
            },
            {
                label: 'No',
                onClick: () => rejectCB()
            }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        keyCodeForClose: [8, 32],
    });
}
export function submitDelete(title, message, cb, rejectCB = () => { }) {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <DeleteModal
                    handleClose={onClose}
                    handleDelete={() => {
                        cb();
                        onClose();
                    }}

                />
            );
        },
        overlayClassName: "confirm-alert-background-change"
    });
}

export function submitAlert(title, message, cb, rejectCB = () => { }) {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <AlertModal
                    text={message}
                    handleClose={onClose}
                    handleDelete={() => {
                        cb();
                        onClose();
                    }}

                />
            );
        },
        overlayClassName: "confirm-alert-background-change"
    });
}

export function useUserManagementHeader() {

    const dispatch = useDispatch();
    return [
        {
            title: 'Username',
            sorter: (a, b) => a.username.localeCompare(b.username),
            width: '20%',
            render: (record, val) => {
                return <div style={{ minWidth: "180px", maxWidth: "180px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{val.username}</p>

                </div>
            }
        },
        {
            title: 'Full Name',
            dataIndex: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (name) => <p style={{ margin: 0, color: "white", minWidth: "150px", maxWidth: "150px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</p>

        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
            render: (email) => <p style={{ margin: 0, color: "white", minWidth: "250px", maxWidth: "250px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{email}</p>
        },
        {
            title: 'Phone Number',
            dataIndex: 'mobile_no',
            width: '23%',
            sorter: (a, b) => a.mobile_no - b.mobile_no,
            render: (mobile_no) => <p style={{ margin: 0, color: "white", minWidth: "200px", maxWidth: "200px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{mobile_no}</p>
        },
        {
            title: 'Login Type',
            dataIndex: 'login_type',
            align: "center",
            render: (login_type) => <p style={{ margin: "0 auto", textTransform: 'capitalize', color: "white", minWidth: "250px", maxWidth: "250px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{login_type}</p>
        },
        {
            title: 'Status',
            width: 230,
            key: 'action',
            render: (record) => {
                const status = (record.online_status == "0") ? 'unblock' : 'block';
                return <div
                    onClick={() =>
                        submitAlert("Change Status", `Are you sure you want to ${status} this user?`, () => dispatch(updateUserManagementThunk({ slug: record.slug, online_status: record.online_status == "0" ? "1" : "0" })))}
                    style={{ width: "100%", cursor: "pointer", background: "black", padding: "3px 15px", display: "flex", alignItems: "center" }}>
                    <a
                        style={{ width: "100%", color: "#7BE35C", marginRight: "30px", color: (record.online_status != "0") ? "#7BE35C" : "#CB0C51" }}>{record.online_status != "0" ? "Active" : "Deactive"}</a>
                    <img src={arrow} alt="Arrow" width={20} height={20} />
                </div>
            },
        },
        {
            title: "Actions",
            width: 230,
            textWrap: 'word-break',
            render: (val) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteUserManagementThunk(val.slug)))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ];
}

export function useSoundTracksHeader(setIsListed, setSoundTrackList, setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Username",
            sorter: (a, b) => a?.username?.localeCompare(b?.username),
            width: 1,
            render: (record, val) => {
                return <div style={{ minWidth: "200px", maxWidth: "200px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{val.username}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            width: 1,
            sorter: (a, b) => a?.email?.localeCompare(b?.email),
            dataIndex: "email",
            render: (email) => <p style={{ margin: 0, color: "white", minWidth: "300px", maxWidth: "300px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{email}</p>
        },
        {
            title: "Track Name",
            width: 1,
            sorter: (a, b) => a.track_name?.localeCompare(b.track_name),
            render: (record, val) => {
                return <div style={{ minWidth: "400px", maxWidth: "400px", display: "inline-flex", flexDirection: "row", alignItems: "center", width: "auto", cursor: 'pointer' }} onClick={() => setFile({ path: record.audio_url, type: 'audio' })}>
                    <img src={require("./images/rect.png")} alt="User Image" style={{ width: "30px", height: "30px" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{val.track_name}</p>

                </div>
            }
        },
        {
            title: "Artist",
            dataIndex: "track_artist",
            width: 1,
            sorter: (a, b) => a.track_artist?.localeCompare(b.track_artist),
            render: (track_artist) => <p style={{ margin: 0, color: "white", minWidth: "200px", maxWidth: "200px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{track_artist}</p>
        },
        {
            title: "Length",
            dataIndex: "duration",
            width: 1,
            align: "center",
            sorter: (a, b) => a.duration - b.duration,
            render: (duration) => <p style={{ margin: "0 auto", color: "white", minWidth: "150px", maxWidth: "150px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{duration}</p>
        },
        {
            title: "Actions",
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteSoundTracksThunk({ audio_slug: val.audio_slug, setSoundTrackList })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
        //{
        //     title: "Soundtracks",
        //     render: (val) => {
        //         return <a onClick={() => {
        //             setSoundTrackList(val.track_list)
        //             setIsListed(false)
        //         }}>View Listings</a>
        //     }
        // }
    ]

    return header;
}

export function useListingHeader(setSoundTrackList, setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Track Name",
            width: "35%",
            sorter: (a, b) => a.track_name?.localeCompare(b.track_name),
            render: (record, val) => {
                return <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", width: "auto", cursor: 'pointer' }} onClick={() => setFile({ path: record.audio_url, type: 'audio' })}>
                    <img src={require("./images/rect.png")} alt="User Image" style={{ width: "30px", height: "30px" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.track_name}</p>

                </div>
            }
        },
        {
            title: "Artist",
            dataIndex: "track_artist",
            width: "35%",
            sorter: (a, b) => a.track_artist?.localeCompare(b.track_artist),
        },
        {
            title: "Length",
            dataIndex: "duration",
            width: "15%",
            align: "center",
            sorter: (a, b) => a.duration - b.duration,
        },
        {
            title: "Actions",
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteSoundTracksThunk({ audio_slug: val.audio_slug, setSoundTrackList })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}

export function useAdminTracksHeader(setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Track Name",
            width: "35%",
            sorter: (a, b) => a.track_name.localeCompare(b.track_name),
            render: (record, val) => {
                return <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", width: "auto", cursor: 'pointer' }} onClick={() => setFile({ path: record.audio_url, type: 'audio' })}>
                    <img src={require("./images/rect.png")} alt="User Image" style={{ width: "30px", height: "30px" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.track_name}</p>

                </div>
            }
        },
        {
            title: "Artist",
            dataIndex: "track_artist",
            width: "35%",
            sorter: (a, b) => a.track_artist.localeCompare(b.track_artist),
        },
        {
            title: "Length",
            dataIndex: "duration",
            width: "15%",
            align: "center",
            sorter: (a, b) => a.duration - b.duration,
        },
        {
            title: "Actions",
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteAdminTracksThunk({ audio_slug: val.slug })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}

export function usePostManagementHeader(setIsListed, setSoundTrackList) {
    const header = [
        {
            title: "Username",
            sorter: (a, b) => a.username.localeCompare(b.username),
            width: '20%',
            render: (record, val) => {
                return <div style={{ minWidth: "250px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{val.username}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            dataIndex: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
            render: (email) => <p style={{ margin: 0, color: "white", minWidth: "250px", maxWidth: "250px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{email}</p>
        }, {
            title: "Listings",
            align: "center",
            render: (val) => {
                return <a onClick={() => {
                    setSoundTrackList(val.post_list)
                    setIsListed(false)
                }}>View Listings</a>
            }
        }
    ]

    return header;
}



export function usePostListingHeader(setUserPostList, setFile) {
    const dispatch = useDispatch();


    const header = [
        {
            title: "Thumbnail",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.thumbnail_url} alt="User Image" style={{ width: "30px", height: "30px", cursor: 'pointer' }} onClick={() => setFile({ path: record.video_url, type: 'video' })} />

                </div>
            }
        },
        {
            title: "Description",
            dataIndex: "description"
        },
        {
            title: "Privacy",
            render: (record, val) => {
                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <p style={{ margin: 0 }}>{record.isPrivate ? "Private" : "Public"}</p>
                </div>
            }
        },
        {
            title: "Views",
            align: "center",
            dataIndex: "views",
            sorter: (a, b) => a.views - b.views,

        },
        {
            title: "Likes",
            align: "center",
            dataIndex: "likes",
            sorter: (a, b) => a.likes - b.likes,
        },
        {
            title: "Actions",
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteUserPostThunk({ post_slug: val.post_slug, setUserPostList })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}

export function useCashOutRequestsHeader(setDetails) {
    const dispatch = useDispatch();
    const [value, setValue] = useState("pending");


    function handleChange(e) {
        const { value } = e.currentTarget;
        if (value != "pending") {
            submitAlert("Confirm Cashout", `Are you sure you want to ${JSON.parse(value).status}?`, () => dispatch(updateCashOutThunk(value)), () => { });
        }
    }

    const header = [
        {
            title: 'Username',
            sorter: (a, b) => a.username?.localeCompare(b.username),
            width: "10%",
            render: (record, val) => {
                return <div style={{ minWidth: "180px", maxWidth: "180px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {val.username}
                    </p>

                </div>
            }
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            width: "20%",
            sorter: (a, b) => a.email?.localeCompare(b.email),
            render: (email) => {
                return <p style={{ minWidth: "100px", width: "fit-content", color: "white", margin: "0", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {email}
                </p>
            }
        },
        {
            title: 'Coins',
            align: 'center',
            sorter: (a, b) => a.amount - b.amount,
            render: (record) => <p>{`${record.amount}`}</p>
        },
        {
            title: 'Total Amount',
            align: 'center',
            sorter: (a, b) => a.total_amount - b.total_amount,
            render: (record) => <p>{`$${record.total_amount}`}</p>
        },
        {
            title: 'Date',
            dataIndex: 'date',
            sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
        },
        {
            title: "Bank Details",
            align: 'center',
            render: (val) => {
                return <a
                    onClick={() => setDetails(val)}
                >
                    View Details
                </a>
            }
        },
        {
            title: 'Status',
            width: 170,
            key: 'action',
            render: (record) => {
                const { status } = record;
                return status != "pending" ? <div style={{ width: "100%", background: "black", textAlign: "center", padding: "3px 15px", display: "flex", alignItems: "center" }}>
                    <a style={{ width: "100%", color: status === "approved" ? "#7BE35C" : "#CB0C51" }}>{status === 'approved' ? 'Approved' : 'Disapproved'}</a>
                </div>
                    : <select value={value}
                        onChange={handleChange}
                        placeholder="pending" style={{ width: "100%", cursor: "pointer", background: "black", padding: "3px 15px", wordWrap: 'break-word', wordBreak: 'break-word', display: "flex", alignItems: "center", color: "grey", cursor: "pointer" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <option value="pending">Pending</option>
                        <option value={JSON.stringify({ ...record, status: "approved" })}>Approved</option>
                        <option value={JSON.stringify({ ...record, status: "disapproved" })}>Disapproved</option>
                    </select>
            },
        },
        {
            title: "Actions",
            width: 230,
            textWrap: 'word-break',
            render: (val) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteCashOutThunk(val.cash_out_slug)))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ];
    return header;
}
{/*  */ }
export function useReportManagementHeader() {
    const dispatch = useDispatch();
    const header = [
        {
            title: 'Reporter',
            sorter: (a, b) => a.source_username.localeCompare(b.source_username),
            render: (record) => {
                return <div style={{ minWidth: "180px", maxWidth: "180px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.source_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.source_username}</p>

                </div>
            }
        },
        {
            title: 'Reporter Email',
            sorter: (a, b) => a.source_email.localeCompare(b.source_email),
            dataIndex: 'source_email',
        },
        {
            title: 'Reportee Username',
            sorter: (a, b) => a.target_username.localeCompare(b.target_username),
            render: (record) => {
                return <div style={{ minWidth: "180px", maxWidth: "180px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.target_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.target_username}</p>

                </div>
            }
        },
        {
            title: 'Reportee Email',
            sorter: (a, b) => a.target_email.localeCompare(b.target_email),
            dataIndex: 'target_email',
        },
        {

            title: 'Reason',
            dataIndex: 'reason',
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="bottom" title={text} overlayStyle={{ width: "auto", maxWidth: "40vw" }}>
                    {(text.length > 10) ? `${text.slice(0, 15)}...` : text}
                </Tooltip>
            ),
        },
        {
            title: 'Date',
            width: 250,
            ellipsis: true,
            dataIndex: 'date',
            sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
        },
        {
            title: 'Status',
            width: 170,
            key: 'action',
            render: (record, val) => {
                const status = (record.status === "block") ? "unblock" : "block";
                const data = {
                    user_slug: record.source_user_slug,
                    target_user_slug: record.target_user_slug,
                    status: record.status === "block" ? "unblock" : "block",
                }
                return <div
                    style={{ width: "100%", cursor: "pointer", background: "black", padding: "3px 15px", display: "flex", alignItems: "center" }}
                    onClick={() => submitAlert("Change Status", `Are you sure you want to ${status} the user?`, () => dispatch(updateReportManagementThunk(data)))}
                >
                    {val.status === "unblock" ?
                        < a style={{ width: "100%", color: "#7BE35C" }}>Unblock</a> :
                        < a style={{ width: "100%", color: "#CB0C51" }}>Block</a>
                    }
                    <img src={arrow} alt="Arrow" width={20} height={20} style={{ marginLeft: "20px" }} />
                </div>
            },
        },
        {
            title: "Actions",
            width: 230,
            textWrap: 'word-break',
            render: (val) => {
                console.log(val)
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deleteReportManagementThunk(val.slug)))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ];
    return header;

}

export const SubscriptionHeader = [
    {
        title: 'Username',
        dataIndex: "fullname",
        render: (record, val) => {
            return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                <img src={require("./images/profile.png")} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                <p style={{ color: "white", margin: "0 15px" }}>{val.fullname}</p>

            </div>
        }
    },
    {
        title: 'Subscription Date',
        dataIndex: 'date',
    },
    {

        title: 'Package',
        dataIndex: 'package',
    },
    {

        title: 'Package Amount',
        dataIndex: 'amount',
    }, {

        title: 'Expiry Date',
        dataIndex: 'expiryDate',
    },
];



export function useSubscriptionHeader(setIsListed, setSubscriptionList) {

    const header = [
        {
            title: "Username",
            sorter: (a, b) => a?.username?.localeCompare(b.username),
            width: '30%',
            render: (record, val) => {
                return <div style={{ minWidth: "250px", maxWidth: "250px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{val.username}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            dataIndex: 'email',
            width: '30%',
            sorter: (a, b) => a?.email?.localeCompare(b.email),
            render: (email) => <p style={{ margin: 0, color: "white", minWidth: "250px", maxWidth: "250px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{email}</p>
        },
        {
            title: "Details",
            align: "center",
            render: (val) => {
                return <a style={{ minWidth: "250px", maxWidth: "250px", }} onClick={() => {
                    setSubscriptionList(val.subscription_list)
                    setIsListed(false)
                }}>View Listings</a>
            }
        },
        {
            title: 'Status',
            width: 170,
            align: "center",
            key: 'action',
            render: (record) => {
                const status = record?.is_expired ? 'Expired' : 'Active';
                return <div
                    style={{ width: "100%", background: "black", padding: "3px 15px", display: "flex", alignItems: "center" }}>
                    <a
                        style={{ width: "100%", color: "#7BE35C", color: !record.is_expired ? "#7BE35C" : "#CB0C51", cursor: "auto" }}>
                        {status}
                    </a>
                </div>
            },
        },
    ]

    return header;
}

export function useUsersSubscriptionsHeader() {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Start Date",
            dataIndex: "start_date",
            sorter: (a, b) => moment(a?.start_date).unix() - moment(b?.start_date).unix(),
            width: '20%',
        },
        {
            title: "Time Period",
            dataIndex: "time_period",
            sorter: (a, b) => parseInt(a?.time_period) - parseInt(b?.time_period),
            align: "center",
        },
        {
            title: "package",
            align: "center",
            sorter: (a, b) => (parseFloat(a?.amount?.replace('$', '')) - parseFloat(b?.amount?.replace('$', ''))) || 0,
            render: (record) => {
                return <p style={{ margin: 0 }}>{record?.amount}</p>
            },
        },
        {
            title: "End Date",
            dataIndex: "end_date",
            sorter: (a, b) => moment(a?.end_date).unix() - moment(b?.end_date).unix(),
            width: '20%',
        },
        {
            title: "Status",
            width: 220,
            textWrap: 'word-break',
            align: "center",
            render: (record) => {
                return <div style={{ width: "100%", background: "black", textAlign: "center", padding: "3px 15px", display: "flex", alignItems: "center" }}>
                    <a style={{ width: "100%", color: "#7BE35C", color: (record.status == "active") ? "#7BE35C" : "#CB0C51" }}>{record.status == "active" ? 'Active' : 'Expired'}</a>
                </div>
            },
        },

    ]
    return header
}



export function useUserDonateHeader(setIsListed, setUserDonateList) {
    const header = [
        {
            title: "Username",
            sorter: (a, b) => a.name?.localeCompare(b.name),
            render: (record) => {

                return <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{record.name}</p>

                </div>
            }
        },
        {
            title: "Email Address",
            dataIndex: "email",
            sorter: (a, b) => a.email?.localeCompare(b.email),
            render: (email) => <p style={{ margin: 0, color: "white", minWidth: "250px", maxWidth: "250px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{email}</p>
        }, {
            title: "Listings",
            align: "center",
            render: (record) => {
                return <a onClick={() => {
                    setUserDonateList({
                        sent: record.sent,
                        recieved: record.recieved
                    })
                    setIsListed(false)
                }}>View Listings</a>
            }
        }
    ]

    return header;
}



export function useUserDonateListing(setDonateList, donateType) {
    const dispatch = useDispatch()

    const header = [
        {
            title: "Donated By",
            sorter: (a, b) => a.donatedBy_name?.localeCompare(b.donatedBy_name),
            width: '22%',
            render: (record, val) => {
                return <div style={{ minWidth: "250px", maxWidth: "250px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.donatedBy_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.donatedBy_name}</p>

                </div>
            }
        },
        {
            title: "Donated To",
            sorter: (a, b) => a.donatedTo_name?.localeCompare(b.donatedTo_name),
            width: '22%',
            render: (record, val) => {
                return <div style={{ minWidth: "250px", maxWidth: "250px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={record.donatedTo_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.donatedTo_name}</p>

                </div>
            }
        },
        {
            title: "Coins",
            dataIndex: "coins",
            sorter: (a, b) => a.coins - b.coins,
            width: '20%',
            align: "center"
        },
        {
            title: "Donated At",
            dataIndex: "created_at",
            sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
            width: '20%',
            align: "center"
        },
        {
            title: "Actions",
            width: 230,
            textWrap: 'word-break',
            render: (val) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion",
                        "Are you sure you want to delete?",
                        () => dispatch(deleteDonateHistoryThunk({
                            slug: val.slug,
                            setDonateList,
                            donateType,
                            user_slug: (donateType === 'sent') ? val.donated_by : val.donated_to
                        }))
                    )}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }

    ]
    return header
}



export function usePostReportListingHeader(setIsListed, setPostReportList, setFile) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Owner Name",
            sorter: (a, b) => a.owner_name.localeCompare(b.owner_name),
            width: '25%',
            render: (record, val) => {
                return <div style={{ minWidth: "250px", maxWidth: "250px", display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                    <img src={val.owner_image_url} alt="User Image" style={{ width: "30px", height: "30px", borderRadius: "100%" }} />
                    <p style={{ color: "white", margin: "0 15px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{val.owner_name}</p>

                </div>
            }
        },
        {
            title: "Post Details",
            align: "center",
            width: '35%',
            render: (record, val) => {
                return <div style={{ minWidth: "150px", margin: "0 auto", display: "flex", flexDirection: "row", alignItems: "center", width: "100%", justifyContent: "center" }}>
                    <img src={record.post_thumbnail_url} alt="User Image" style={{ width: "30px", height: "30px", cursor: 'pointer' }} onClick={() => setFile({ path: record.post_video_url, type: 'video' })} />

                </div>
            }
        },
        {
            width: 200,
            render: (val) => {
                return <a style={{ whiteSpace: "nowrap" }} onClick={() => {
                    setPostReportList(val.report_list)
                    setIsListed(false)
                }}>View Listings</a>
            }
        },
        {
            width: 200,
            textWrap: 'word-break',
            render: (val, record) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to permanently delete this post?", () => dispatch(deleteUserReportedPostThunk({ post_slug: val.post_slug })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }
    ]
    return header
}



export function usePostReportUserListing(setPostReportList) {
    const dispatch = useDispatch();
    const header = [
        {
            title: "Reporter Name",
            sorter: (a, b) => a.user_name.localeCompare(b.user_name),
            width: '25%',
            render: (record, val) => {
                return <div style={{ minWidth: "250px", maxWidth: "250px", display: "inline-flex", flexDirection: "row", alignItems: "center", width: "auto", cursor: 'pointer' }}>
                    <img src={val.user_image_url} alt="User Image" style={{ width: "30px", height: "30px" }} />
                    <p style={{ color: "white", margin: "0 15px" }}>{val.user_name}</p>

                </div>
            }
        },
        {
            title: "Reason",
            dataIndex: "comments",
            render: (text) => {
                return <Tooltip placement="bottom" title={text} overlayStyle={{}}><p style={{
                    margin: 0, WebkitBoxOrient: "vertical", WebkitLineClamp: 1,
                    overflow: "hidden",
                    display: "-webkit-box",
                    textOverflow: "ellipsis"
                }}> {text}</p>
                </Tooltip>
            }
        },
        {
            title: "Reported On",
            width: '25%',
            dataIndex: "created_at",
            sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
            render: (name) => <p style={{ margin: 0, color: "white", minWidth: "150px", maxWidth: "150px", display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</p>
        },
        {
            title: "Actions",
            width: 230,
            textWrap: 'word-break',
            render: (val) => {
                return <div
                    style={{ display: "flex", flexDirection: "row", color: "#CB0C51", alignItems: "center", cursor: "pointer" }}
                    onClick={() => submitDelete("Confirm Deletion", "Are you sure you want to delete?", () => dispatch(deletePostReportThunk({ slug: val.slug, setPostReportList })))}
                >
                    <img src={bin} alt="" />
                    <p style={{ margin: "0 10px" }} >Delete</p>
                </div>
            }
        }

    ]
    return header
}
